import { render, staticRenderFns } from "./fulfillment-picking-queue.vue?vue&type=template&id=16ba6dd0&scoped=true&"
import script from "./js/fulfillment-picking-queue.js?vue&type=script&lang=js&"
export * from "./js/fulfillment-picking-queue.js?vue&type=script&lang=js&"
import style0 from "./fulfillment-picking-queue.vue?vue&type=style&index=0&id=16ba6dd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ba6dd0",
  null
  
)

export default component.exports